import { render, staticRenderFns } from "./BsaHomeLayout.vue?vue&type=template&id=cb503ba4"
import script from "./BsaHomeLayout.vue?vue&type=script&lang=js"
export * from "./BsaHomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb503ba4')) {
      api.createRecord('cb503ba4', component.options)
    } else {
      api.reload('cb503ba4', component.options)
    }
    module.hot.accept("./BsaHomeLayout.vue?vue&type=template&id=cb503ba4", function () {
      api.rerender('cb503ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/bsa/BsaHomeLayout.vue"
export default component.exports